(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

  function money(cents) {
    try {
      return new Intl.NumberFormat('it-IT', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }
  window.zvMoney = money;

  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2800);
  }

  var mobileNav = document.querySelector('[data-mobile-nav]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]') && mobileNav) {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    if (e.target.closest('[data-menu-close]') && mobileNav) {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  var drawer = document.querySelector('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer) { window.location.href = root + 'cart'; return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('[data-cart-close].icon-btn');
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  function refreshDrawer() {
    return fetch(root + '?sections=zv-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['zv-cart-drawer'];
        if (!html || !drawer) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-drawer-inner]');
        var current = drawer.querySelector('[data-cart-drawer-inner]');
        if (fresh && current) current.replaceWith(fresh);
        var c = tmp.querySelector('[data-count-value]');
        if (c) updateCount(parseInt(c.getAttribute('data-count-value'), 10) || 0);
      });
  }

  function changeLine(line, quantity) {
    var inner = drawer && drawer.querySelector('[data-cart-drawer-inner]');
    if (inner) inner.classList.add('is-loading');
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () {
      if (document.body.hasAttribute('data-cart-page')) { window.location.reload(); return; }
      return refreshDrawer();
    });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener && drawer) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    var ch = e.target.closest('[data-line-change]');
    if (ch) {
      e.preventDefault();
      changeLine(parseInt(ch.getAttribute('data-line'), 10), parseInt(ch.getAttribute('data-qty'), 10));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      if (mobileNav) { mobileNav.classList.remove('is-open'); document.body.style.overflow = ''; }
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var err = form.querySelector('[data-form-error]');
    if (err) { err.textContent = ''; err.hidden = true; }
    if (btn) btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.body && (res.body.description || res.body.message)) || 'Non è stato possibile aggiungere il prodotto.';
          if (err) { err.textContent = msg; err.hidden = false; } else { toast(msg); }
          return;
        }
        return refreshDrawer().then(function () {
          if (drawer) { openDrawer(); } else { toast('Aggiunto al carrello'); }
        });
      })
      .catch(function () { toast('Errore di connessione, riprova.'); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  document.querySelectorAll('[data-product]').forEach(function (wrap) {
    var dataEl = wrap.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var idInput = wrap.querySelector('input[name="id"]');
    var qtyInput = wrap.querySelector('[data-qty-input]');
    var priceEl = wrap.querySelector('[data-price]');
    var compareEl = wrap.querySelector('[data-compare]');
    var btn = wrap.querySelector('[data-add-btn]');
    var btnLabel = wrap.querySelector('[data-add-label]');
    var mainImg = wrap.querySelector('[data-main-img]');

    function selectedOptions() {
      return Array.prototype.map.call(wrap.querySelectorAll('[data-option]'), function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function currentVariant() {
      var sel = selectedOptions();
      if (!sel.length) return product.variants[0];
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      });
    }
    function render() {
      var v = currentVariant();
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      if (!v) {
        if (btn) btn.disabled = true;
        if (btnLabel) btnLabel.textContent = 'Non disponibile';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      if (btn) btn.disabled = !v.available;
      if (btnLabel) btnLabel.textContent = v.available ? 'Aggiungi al carrello — ' + money(v.price * qty) : 'Esaurito';
      if (v.featured_image && mainImg) {
        mainImg.src = v.featured_image.src;
      }
      if (window.history && window.history.replaceState && product.variants.length > 1) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    wrap.addEventListener('change', function (e) {
      if (e.target.closest('[data-option]') || e.target === qtyInput) render();
    });
    wrap.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      if (step && qtyInput) {
        e.preventDefault();
        var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10);
        qtyInput.value = Math.max(1, Math.min(99, n));
        render();
      }
      var thumb = e.target.closest('[data-thumb]');
      if (thumb && mainImg) {
        mainImg.src = thumb.getAttribute('data-thumb');
        wrap.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      }
    });
    if (qtyInput) qtyInput.addEventListener('input', render);
    render();
  });

  var para = document.querySelector('[data-parallax]');
  if (para && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = Math.min(window.scrollY, 900);
        para.style.transform = 'translateY(' + (y * -0.08) + 'px)';
        ticking = false;
      });
    }, { passive: true });
  }

  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  var sortSel = document.querySelector('[data-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
  var filterInput = document.querySelector('[data-filter-input]');
  if (filterInput) {
    var cards = document.querySelectorAll('[data-card-title]');
    var countEl = document.querySelector('[data-results-count]');
    var emptyEl = document.querySelector('[data-filter-empty]');
    filterInput.addEventListener('input', function () {
      var q = filterInput.value.trim().toLowerCase();
      var n = 0;
      cards.forEach(function (c) {
        var match = !q || c.getAttribute('data-card-title').indexOf(q) !== -1;
        c.hidden = !match;
        if (match) n++;
      });
      if (countEl) countEl.textContent = n + (n === 1 ? ' prodotto' : ' prodotti');
      if (emptyEl) emptyEl.hidden = n !== 0;
    });
  }
  document.addEventListener('click', function (e) {
    var reset = e.target.closest('[data-filter-reset]');
    if (reset && filterInput && filterInput.value) {
      e.preventDefault();
      filterInput.value = '';
      filterInput.dispatchEvent(new Event('input'));
      filterInput.focus();
    }
  });
})();